export const SUBSCRIPTION_VIEWS = ['none', 'active', 'cancelling', 'paused', 'pauseScheduled'];

/**
 * Derives which billing view to render. A pending cancellation wins over a pause because the customer
 * has to see (and be able to revert) the cancellation; `orgPlan` rather than the subscription payload
 * decides "paused" because the plan is what gates access.
 *
 * @param {Object} params
 * @param {Object|null|undefined} params.subscription - GET /subscription payload
 * @param {string|null|undefined} params.orgPlan - organizations.plan, 'paused' while a pause is in effect
 * @returns {'none'|'active'|'cancelling'|'paused'|'pauseScheduled'}
 */
export function resolveSubscriptionView({ subscription, orgPlan }) {
	const isPaused = orgPlan === 'paused';
	if (!subscription && !isPaused) return 'none';
	if (subscription?.cancelAtPeriodEnd) return 'cancelling';
	if (isPaused) return 'paused';
	if (subscription?.pause) return 'pauseScheduled';
	return 'active';
}

/**
 * Whether a pause can actually be offered. The backend keeps `canPause` true while it has no window to
 * offer (its local period end is stale until the period-roll webhook lands), and an offer without a
 * selectable option would be a dead end.
 *
 * @param {{ canPause?: boolean, pauseOptions?: Array<Object> }|null|undefined} retention
 * @returns {boolean}
 */
export function canOfferPause(retention) {
	return Boolean(retention?.canPause && retention.pauseOptions?.length);
}
